import { render, staticRenderFns } from "./DatosDeportistaCard.vue?vue&type=template&id=5429c6ca"
import script from "./DatosDeportistaCard.vue?vue&type=script&setup=true&lang=js"
export * from "./DatosDeportistaCard.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports